import { ChoiceStatus } from '@payflip/utils';
import { PropsWithChildren } from 'react';
import { StyledOrderStatusTag } from './styled';

export function OrderStatusTag({
  orderStatus,
  children
}: PropsWithChildren & { orderStatus: ChoiceStatus }): JSX.Element {
  return (
    <StyledOrderStatusTag status={orderStatus}>{children}</StyledOrderStatusTag>
  );
}
